import styled from 'styled-components';

export const EditorContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 6px 0;
`;
export const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 10px 4px 10px;
  position: relative;
`;

export const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  span {
    margin-left: 4px;
    font-size: 14px;
    color: ${(props) => props.$themecolor ?? '#333'};
  }
`;
export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px 0 0;

  img {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  &:hover {
    //background-color: #f2f2f2;
    border-radius: 2px;
    cursor: pointer;
    // cursor: ${(props) => (props.$editordisabled ? 'not-allowed' : 'pointer')};
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  width: 100%;
  height: calc(100% - 27px);
  padding-right: 6px;
  padding-left: 10px;
  box-sizing: border-box;

  img {
    width: 20px;
    height: 20px;
  }
`;
export const InputContainer = styled.div`
  width: calc(100% - 20px);
  height: 100%;
  padding: 4px 0;
  box-sizing: border-box;
`;
export const Textarea1 = styled.textarea`
  width: 100%;
  height: 100%;
  padding-left: 4px;
  line-height: 1.3;

  resize: none;
  border: none;
  border-radius: 0;
  box-shadow: none;
  outline: none;
  font-size: 16px;

  &:focus {
    outline: none;
  }
  textarea:focus {
    outline: none;
    box-shadow: none;
    border: none;
    background-color: inherit; /* 保持背景色一致 */
    color: inherit; /* 保持文本颜色一致 */
  }

  /* 移除悬停样式 */
  textarea:hover {
    outline: none;
    box-shadow: none;
    border: none;
    background-color: inherit; /* 保持背景色一致 */
    color: inherit; /* 保持文本颜色一致 */
  }
`;
export const IconContainer = styled.div`
  display: flex;
  align-items: flex-end;
  img {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
`;

export const EmojiListContainer = styled.div`
  position: absolute;
  top: -226px;
  left: 15px;
  width: 260px;
  height: 220px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.3);
`;
export const EmojiListWrapper = styled.div`
  box-sizing: border-box;
  padding: 2px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
`;

export const EmojiItem = styled.div`
  width: 42px;
  height: 42px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;

  &:hover {
    background-color: #f2f2f2;
    border-radius: 2px;
  }
`;
